import { render, staticRenderFns } from "./cookie-banner-installation-events-card.vue?vue&type=template&id=17322995"
import script from "./cookie-banner-installation-events-card.vue?vue&type=script&lang=js"
export * from "./cookie-banner-installation-events-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports